import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import JobService from "../Controller/JobController";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import JobDetailModal from "./JobDetail";
import BASE_URL from "../../../config/config";
import ProjectService from "../../Setup/controller/ProjectMemberController/ProjectMemberController";
import { handleChange, handleSubmit } from "../Controller/CreateJobController";
import { fetchActiveDateFormat } from '../../Common/fetchDateFormat';
import Common from '../../Common/Common';
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import HelpSite from "../../Common/HelpLink";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import { useTranslation } from 'react-i18next';
import CreateJobSummary from "./JobForms/CreateJobSummary";
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";
import Cookies from "js-cookie";
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import Draggable from 'react-draggable';
import UserService from "../../Setup/controller/UserController/UserController";
import CustomerService from "../../Customer/Controller/CustomerController";
import SendAttachment from "../../Common/SendAttachment";

import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";

import { PDFDocument } from "pdf-lib";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
function JobList({ CustomerID, AssetID, StockID, ContractID, JobTab }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };

  const activeDateFormat = useDateFormat();
  const RoleID = localStorage.getItem('RoleID');
  const HelpLink = localStorage.getItem('HelpLink');
  const location = useLocation();
  const url = new URL(window.location.origin + location.pathname);
  const pathname = "/job/job-list";
  const tableRef = useRef();
  const FormAction = "/JobsList";
  //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
  const [currentJobs, setCurrentJobs] = useState(null);
  const [modalInstance, setModalInstance] = useState(null);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme === "dark") {
    accordTheme = "accordion-header-dark";
  }
  const CompanyID = localStorage.getItem("CompanyID");
  const [jobList, setJobData] = useState([]);
  const [JobCount, setJobCount] = useState(0);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
  const [ProjectList, setProject] = useState([]);
  const [formData, setFormData] = useState({
    IsOutstanding: 1,
    IsUnassigned: 0
  });
  const [ProjectID, setProjectID] = useState(localStorage.getItem("ProjectID") || ""); // Initial empty state
  const [validationError, setValidationError] = useState('');
  const [filteredJobList, setFilteredJobList] = useState([]); // Filtered job list
  const [showCompleted, setShowCompleted] = useState(1);
  const [showUnassigned, setShowUnassigned] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState("0");
  const [currentPage, setCurrentPage] = useState(1); // Current page
  // Items per page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const UserID = localStorage.getItem("UserID");
  const [multipleIds, setMultipleIds] = useState([]);
  const [searchFields, setSearchFields] = useState([]);
  const [selectedUser, setSelectedUser] = useState("0");
  const [selectedRoleName, setRoleName] = useState(localStorage.getItem("RoleName"));
  const [recentSearches, setRecentSearches] = useState([]);
  const [isMultipleEmailModalOpen, setIsMultipleEmailModalOpen] = useState(false);
  const [pdfAttachment, setPdfAttachment] = useState(null);
  const [Email, setEmail] = useState();
  const setSortConfigInCookie = (config) => {
    Cookies.set(`JobSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`JobSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'IssueID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
  const [users, setUsers] = useState([]);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isJobModalOpen, setIsJobModalOpen] = useState(false);
  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };
  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };
  // Helper to get page size from cookie
  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("10");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }
  const fetchUsers = async () => {
    try {
      const redirectCallback = () => navigate("/");
      const usersData = await UserService.getAllUsers(redirectCallback);
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };


  useEffect(() => {
    UserLockRelease();
    fetchUsers();
    fetchSearchLog();
    fetchJob(ProjectID, currentPage, pageSize, showCompleted, showUnassigned);
  }, [ProjectID, currentPage, pageSize, CustomerID, showCompleted, showUnassigned]);

  useEffect(() => {
    fetchJob(ProjectID, currentPage, pageSize, showCompleted, showUnassigned);
  }, [ProjectID, sortConfig, CustomerID, showCompleted, showUnassigned]);
  useEffect(() => {

    handleSearchButtonClick();

  }, [selectedUser]);
  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };

  const handleFieldChange = (event) => {
    handleChange(event, formData, setFormData);
    if (event.target.name === "ProjectID") {
      setProjectID(event.target.value);
      localStorage.setItem("ProjectID", event.target.value);
      fetchJob(event.target.value, "0", "10", showCompleted);
    }
  };

  const fetchJob = async (projectID, page, size, showCompleted, isUnassigned = showUnassigned) => {

    setLoading(true); // Start loading
    try {
      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();
      const redirectCallback = () => navigate('/');
      let IsCompleted = 1;
      if (showCompleted === 1) {
        //jobsData = jobsData.filter(x => x.IsCompleted === 0);
        IsCompleted = 0;
      }
      let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
      let jobsData = await JobService.GetAllJobs(redirectCallback, CustomerID, AssetID, StockID, ContractID, projectID, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), IsCompleted, columnsToSearch, selectedUser, isUnassigned);
      if (showCompleted === 1) {
        //jobsData = jobsData.filter(x => x.IsCompleted === 0);
      }
      let JobCount = await JobService.GetJobCount(redirectCallback, CustomerID, AssetID, StockID, ContractID, projectID, searchQuery, IsCompleted, columnsToSearch,
        selectedUser, isUnassigned);
      setJobCount(JobCount[0].JobCount);
      //setJobCount(jobsData.length);

      setJobData(jobsData);
      setFilteredJobList(jobsData); // Update filtered list for rendering
      setTotalPages(Math.ceil(JobCount[0].JobCount / size)); // Set total pages dynamically
    } catch (error) {
      console.error('Error fetching jobs:', error);
    } finally {
      setLoading(false); // Stop loading after fetching
    }
  };

  useEffect(() => {

    const fetchProject = async () => {
      try {

        const redirectCallback = () => navigate('/');
        const list = await ProjectService.GetProjectMemberByID(redirectCallback);
        // console.log(list)
        if (list[0].length > 0) {
          const filteredList = list.filter(project => project.ID !== 0); // Remove project with ID 0
          //console.log("after: "+filteredList)
          setProject(filteredList[0]);
          if (filteredList.length > 0) {
            let initialProjectID;
            if (localStorage.getItem("ProjectID") == null || localStorage.getItem("ProjectID") == "undefined") {

              const DefaultProjectList = list[0].filter(project => project.IsDefault == "1");

              if (DefaultProjectList.length > 0) {
                initialProjectID = DefaultProjectList[0].ID;
              }
              else {
                initialProjectID = filteredList[0][0].ID;
              }
            }
            else {
              initialProjectID = localStorage.getItem("ProjectID");
            }
            setProjectID(initialProjectID);
            localStorage.setItem("ProjectID", initialProjectID);
            // fetchJob(initialProjectID, "0", "10");
          }
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    };

    fetchProject();

  }, [CustomerID, AssetID, StockID, ContractID, JobTab]);

  const handleCloseModal = async (isChanged) => {

    const closeModal = async () => {
      await JobService.UnLockJob(localStorage.getItem('JobID'));
      localStorage.setItem('JobID', "0");
      fetchJob(ProjectID, currentPage, pageSize, searchQuery);
      setMultipleIds([]);
      setIsJobModalOpen(false);
    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });
  };
  const handleCloseSummaryModal = async () => {
    localStorage.setItem('JobID', "0");
    setCurrentPage(1);
    setIsModalOpen(false);
  };
  const handleSuccessSummaryModal = async (submissionType, JobID) => {
    debugger;
    localStorage.setItem('JobID', "0");
    fetchJob(ProjectID, currentPage, pageSize, searchQuery);
    setIsModalOpen(false);
    if (submissionType === "1") {
      handleEditClick(JobID);
    }

  };

  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await JobService.DeleteJob(redirectCallback, multipleIds);
            setMultipleIds([]);
            fetchJob(ProjectID, currentPage, pageSize, searchQuery);
            setCurrentPage(1);
            setSelectedId("0");
            Swal.fire(
              t('deleteSuccess'),
              t('deleteSuccessMessage'),
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              t('deleteError'),
              t('deleteErrorMessage'),
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete job.',
        'warning'
      );
    }
  };

  const handleCreateJobClick = () => {

    localStorage.setItem('JobID', "0");
    localStorage.setItem('JobCostID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    if (ProjectID) {
      setIsModalOpen(true);
      setValidationError(''); // Clear any previous validation error
    } else {
      Swal.fire(
        'Error!',
        'Please select at least one project to create the job.',
        'warning'
      );
    }
  };
  const fetchJobDetail = async (newJobID) => {
    try {
      const jobDetail = await JobService.GetJobByID(redirectCallback, newJobID);
      return jobDetail;
    }
    catch (error) {
      alert(error);
    }
  };
  const handleEditClick = async (JobID) => {
    try {
      const IsAlreadyLeadID = localStorage.getItem('JobID');
      if (IsAlreadyLeadID) {
        await JobService.UnLockJob(IsAlreadyLeadID);
      }
      const JobDetail = await fetchJobDetail(JobID);
      if (JobDetail.length > 0) {
        localStorage.setItem('JobID', JobID);
        localStorage.setItem('HasRecordUpdated', "0");
        setSelectedId(JobID);
        setIsJobModalOpen(true);

      }
    }
    catch (error) {
      alert(error);
    }
  };


  const handleCheckboxChange = (event) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      IsOutstanding: event.target.checked, // Assuming IssuePriorityID is the field name
    }));
    // setJobData([]);
    if (event.target.checked === true) {
      setShowCompleted(1);
    }
    else {
      setShowCompleted(0);
    }
  };
  const handleUnassignedCheckboxChange = (event) => {

    if (event.target.checked === true) {
      setShowUnassigned(1);
    }
    else {
      setShowUnassigned(0);
    }
    // Optional: reset to first page
    setCurrentPage(1);

    // Optional: clear selected jobs
    setMultipleIds([]);
  };
  const handleRowCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };
  const IsModuleAssigned = async () => {
    try {
      const CompanyID = localStorage.getItem("CompanyID");
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "10");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const handlePageChange = (page) => {
    setJobData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };

  // Handle Page Size Change
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };



  const handleSort = async (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);
    let IsCompleted = 1;
    if (showCompleted === 1) {
      //jobsData = jobsData.filter(x => x.IsCompleted === 0);
      IsCompleted = 0;
    }
    setSortConfig({ key, direction });
    const jobsData = await JobService.GetAllJobs(
      redirectCallback,
      CustomerID,
      AssetID,
      StockID,
      ContractID,
      ProjectID,
      "1",
      pageSize.toString(),
      searchQuery.toString(),
      key.toString(),  // Use current sortConfig directly
      direction.toString(),
      IsCompleted, "", selectedUser,
      showUnassigned
    );

    const JobCount = await JobService.GetJobCount(
      redirectCallback,
      CustomerID,
      AssetID,
      StockID,
      ContractID,
      ProjectID,
      searchQuery,
      IsCompleted, "", selectedUser,
      showUnassigned
    );

    setJobCount(JobCount[0].JobCount);
    setJobData(jobsData);
    setFilteredJobList(jobsData);
    setTotalPages(Math.ceil(JobCount[0].JobCount / pageSize));
  };
  const handleSearchButtonClick = async () => {

    setCurrentPage(1); // Reset to first page
    setJobData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let IsCompleted = 1;
    if (showCompleted === 1) {
      //jobsData = jobsData.filter(x => x.IsCompleted === 0);
      IsCompleted = 0;
    }
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";

    const jobsData = await JobService.GetAllJobs(
      redirectCallback,
      CustomerID,
      AssetID,
      StockID,
      ContractID,
      ProjectID,
      currentPage,
      pageSize.toString(),
      query.toString(),
      sortConfig.key.toString(),
      sortConfig.direction.toString(),
      IsCompleted,
      columnsToSearch,
      selectedUser,
      showUnassigned
    );

    setJobData(jobsData); // Update data

    const JobCount = await JobService.GetJobCount(redirectCallback, CustomerID, AssetID, StockID, ContractID, ProjectID, searchQuery, IsCompleted, columnsToSearch,
      selectedUser, showUnassigned);
    setJobCount(JobCount[0].JobCount);


    setJobData(jobsData);
    setFilteredJobList(jobsData); // Update filtered list for rendering
    setTotalPages(Math.ceil(JobCount[0].JobCount / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("10");
    setRecentSearches(searchList);
  };

  const defaultColumns = [
    "jobNo",
    "jcustomer",
    "priority",
    "category",
    "Jdescription",
    "JdueDate",
    "JdateCreated",
    "assignedTo",
    "Jprice",
    "Jstatus",
    "ModifiedBy",
    "vc_SupplierInvoiceNo",
    "Address1"
  ];

  const columnOptions = [
    { value: "jobNo", label: "Job No" },
    { value: "jcustomer", label: "Customer" },
    { value: "priority", label: "	Priority" },
    { value: "category", label: "Category" },
    { value: "Jdescription", label: "Description" },
    { value: "JdueDate", label: "Due Date" },
    { value: "JdateCreated", label: "Date Created" },
    { value: "assignedTo", label: "Assigned To" },
    { value: "Jprice", label: "Price" },
    { value: "Jstatus", label: "Status" },
    { value: "LastActioned", label: "Updated Date" },
    { value: "ModifiedBy", label: "ModifiedBy" },
    { value: "vc_SupplierInvoiceNo", label: "Cust. Order No." },
    { value: "Address1", label: "Address" },

  ];
  const defaultColumnsForSearch = [
    "bnt_OrderNumber",
    "CompanyName",
    "PriorityName",
    "CategoryName",
    "IssueTitle",
    "TimeToCall",
    "DateCreated",
    "DisplayName",
    "Prices",
    "StatusName",
    "ModifiedBy",
    "vc_SupplierInvoiceNo",
     "Address1"
  ];
  const columnSearchOptions = [
    { value: "bnt_OrderNumber", label: "Job No" },
    { value: "CompanyName", label: "Customer" },
    { value: "PriorityName", label: "	Priority" },
    { value: "CategoryName", label: "Category" },
    { value: "IssueTitle", label: "Description" },
    { value: "TimeToCall", label: "Due Date" },
    { value: "DateCreated", label: "Date Created" },
    { value: "DisplayName", label: "Assigned To" },
    { value: "Prices", label: "Price" },
    { value: "StatusName", label: "Status" },
    { value: "ModifiedBy", label: "ModifiedBy" },
    { value: "vc_SupplierInvoiceNo", label: "Cust. Order No." },
    { value: "Address1", label: "Address" },
  ];

  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`JobsColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`JobsColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);
  };

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);
  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "10");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 104;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const handlePrintUser = async (event) => {
    event.stopPropagation();


    setLoading(true);
    const includeTerms = false;

    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));
        }



        // ================= FINAL OUTPUT =================
        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };
  const handleStart = (e, ui) => {
    e.stopPropagation();
  }

  const handleExportExcel = async () => {

    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);
    try {
      debugger;
      // Filter only selected customers
      const selectedJob = jobList.filter(job =>
        multipleIds.includes(job.IssueID)
      );

      if (!selectedJob || selectedJob.length === 0) {
        Swal.fire(
          'Warning!',
          'No selected data to export.',
          'warning'
        );
        return;
      }

      const headers = visibleColumns.map(col =>
        columnOptions.find(opt => opt.value === col)?.label || col
      );

      const rows = selectedJob.map(row =>
        visibleColumns.map(col => {
          let value = row[col];
          if (col === "jobNo") {
            value = `${row.bnt_OrderNumber ?? ""}`;
          }
          if (col === "jcustomer") {
            value = `${row.CompanyName ?? ""}`;
          }
          if (col === "priority") {
            value = `${row.PriorityName ?? ""}`;
          }
          if (col === "category") {
            value = `${row.CategoryName ?? ""}`;
          }
          if (col === "Jdescription") {
            value = `${row.IssueTitle ?? ""}`;
          }
          if (col === "JdueDate") {
            value = `${row.TimeToCall ?? ""}`;
          }
          if (col === "JdateCreated") {
            value = `${row.DateCreated ?? ""}`;
          }
          if (col === "assignedTo") {
            value = `${row.DisplayName ?? ""}`;
          }
          if (col === "Jprice") {
            value = `${row.Prices ?? ""}`;
          }
          if (col === "Jstatus") {
            value = `${row.StatusName ?? ""}`;
          }
          return `"${(value ?? '').toString().replace(/"/g, '""')}"`;
        }).join(',')
      );

      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Jobs.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected customers:', error);
    } finally {
      setLoading(false);
    }
  };
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);

  // NEW: handle click (not change)
  const handleCheckboxClick = (event, id, index) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = jobList.slice(start, end + 1).map(l => l.IssueID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);
  };

  const handleSendMultipleEmail = async () => {
    if (multipleIds.length > 0) {

      const emails = multipleIds
        .map(id => {
          const contact = jobList.find(c => c.IssueID === id);
          return contact ? contact.Email : '';
        })
        .filter(email => email);
      debugger;
      setEmail(emails[0]);

      const id = multipleIds[0];
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        paramIssueId: id
      };

      const JasperReport = await JasperReportService.GetJasperReportByID("104");
      let url = JasperReport[0].Link;
      debugger;
      Object.keys(currentInputValues).forEach((key) => {
        const placeholder = new RegExp(`{${key}}`, "g");
        url = url.replace(placeholder, currentInputValues[key]);
      });

      const queryObj = {
        ...currentInputValues,
        format: "pdf",
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const queryString = new URLSearchParams(queryObj).toString();

      // ?? GET PDF as BLOB from API
      const response = await axiosInstance.get(`/Dashboard/ProxyReport?${queryString}`, {
        responseType: "blob",
      });

      // ?? Convert Blob ? File
      const pdfFile = new File(
        [response.data],
        `${JasperReport[0].ReportName}.pdf`,
        { type: "application/pdf" }
      );

      // ?? Save to state (to send email)
      setPdfAttachment(pdfFile);

      // ?? Open Email Modal
      setIsMultipleEmailModalOpen(true);
    }
    else {
      Swal.fire('Error!', 'Please check at least one record.', 'warning');
    }
  }
  const handleCloseEmailModal = async () => {
    setIsMultipleEmailModalOpen(false);

  };
  const getInitialWidths = () => {
    const saved = Cookies.get(`JobColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`JobColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [jobList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `JobColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `JobColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };

  return (
    <div>
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      {(CustomerID === 0 || CustomerID === "") && (AssetID === 0 || AssetID === "")
        && (StockID === 0 || StockID === "") && (ContractID === 0 || ContractID === "") && (
          <Common showAddButton={'yes'} handleAddTask={handleCreateJobClick}
            showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick} ModuleID={"10"}
            showExportButton={'yes'} handleExportExcel={handleExportExcel}
            showPrintUser={'yes'} handlePrintUser={handlePrintUser}
            showEmailButton={'yes'} handleSendEmail={handleSendMultipleEmail}
            IsAttachment="1"
            isDisabled={multipleIds.length > 1}
            HelpFormName="Job List" HelpModule="11"
            RecordID={multipleIds}
          />
        )}
      <div className="main-content-header">
        <div className="row mb-3" style={{ marginLeft: "-5px" }}>
          {(CustomerID === 0 &&
            <div className="col-sm-2">
              <h1>{t('jobs')}</h1>
            </div>
          )}

          {(CustomerID > 0 &&
            <div className="col-sm-2">
              <button className='btn btn-primary btn-sm' onClick={handleCreateJobClick}>
                <i className="icofont-plus" aria-hidden="true"> {t('addNew')}</i>
              </button>
            </div>
          )}


          <div className="col-sm-2">
            <input
              className="form-check-input"
              type="checkbox"
              name="IsOutstanding"
              checked={formData.IsOutstanding}
              onChange={handleCheckboxChange}
            />
            <label style={{ marginLeft: "15px" }}>
              {t('outstandingOnly')}
            </label>
          </div>

          <div className="col-sm-2">
            <input
              className="form-check-input"
              type="checkbox"
              name="IsUnassigned"
              checked={showUnassigned === 1}
              onChange={handleUnassignedCheckboxChange}
            />
            <label style={{ marginLeft: "15px" }}>
              Unassigned Jobs
            </label>
          </div>

          <div className="col-sm-3" style={{ display: "flex", alignItems: "center" }}>
            <span style={{ marginRight: "10px", whiteSpace: "nowrap" }}>Project:</span>
            <select name="ProjectID" className='form-control' value={localStorage.getItem("ProjectID")} onChange={handleFieldChange}>

              {ProjectList.map((project) => (
                <option key={project.ID} value={project.ID}>
                  {project.ProjectName}
                </option>
              ))}
            </select>

          </div>

          <div className="col-xl-3 d-flex justify-content-end">

            {selectedRoleName === "Administrator" && (
              <><span style={{ padding: "5px" }}> Filter By</span>
                <select
                  className="form-control"
                  style={{ marginRight: "5px", "width": "30%" }}
                  value={selectedUser}
                  onChange={(e) => setSelectedUser(e.target.value)}
                >
                  <option value="0">All Engineers</option>
                  {users.map((user) => (
                    <option key={user.UserID} value={user.UserID}>
                      {user.DisplayName}
                    </option>
                  ))}
                </select>
              </>
            )}


            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}

            />

          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="">
                <div className="row mb-3">


                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>



                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>



                </div>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "max-content",
                      minWidth: "100%"
                    }}
                    className="table m-0 table-hover"
                    ref={tableRef}
                  >
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th
                          className="checkbox-header"
                          style={{
                            width: "40px",
                            minWidth: "40px",
                            maxWidth: "40px",
                            position: "sticky",
                            left: 0,
                            zIndex: 5,

                          }}
                        ></th>
                        {visibleColumns.includes("jobNo") &&
                          <th onClick={() => handleSort('IssueID')}
                            style={{
                              width: `${columnWidths?.IssueID}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}

                            className="resizable ellipsis">{t('jobNo')} <i
                              className={`ms-1 icofont ${sortConfig.key === 'IssueID'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "IssueID");
                              }}
                              onDoubleClick={() => autoFitColumn("IssueID")}
                            /> </th>
                        }
                        {visibleColumns.includes("jcustomer") &&
                          <th onClick={() => handleSort('CompanyName')}

                            style={{
                              width: `${columnWidths?.CompanyName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('customer')}  <i
                              className={`ms-1 icofont ${sortConfig.key === 'CompanyName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "CompanyName");
                              }}
                              onDoubleClick={() => autoFitColumn("CompanyName")}
                            /></th>
                        }
                        {visibleColumns.includes("priority") &&
                          <th onClick={() => handleSort('PriorityName')}

                            style={{
                              width: `${columnWidths?.PriorityName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('priority')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'PriorityName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "PriorityName");
                              }}
                              onDoubleClick={() => autoFitColumn("PriorityName")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("category") &&
                          <th onClick={() => handleSort('CategoryName')}

                            style={{
                              width: `${columnWidths?.CategoryName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('category')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'CategoryName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "CategoryName");
                              }}
                              onDoubleClick={() => autoFitColumn("CategoryName")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Jdescription") &&
                          <th onClick={() => handleSort('IssueTitle')}

                            style={{
                              width: `${columnWidths?.IssueTitle}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('description')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'IssueTitle'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "IssueTitle");
                              }}
                              onDoubleClick={() => autoFitColumn("IssueTitle")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("JdueDate") &&
                          <th onClick={() => handleSort('TimeToCall')}

                            style={{
                              width: `${columnWidths?.TimeToCall}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('dueDate')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'TimeToCall'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "TimeToCall");
                              }}
                              onDoubleClick={() => autoFitColumn("TimeToCall")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("JdateCreated") &&
                          <th onClick={() => handleSort('DateCreated')}

                            style={{
                              width: `${columnWidths?.DateCreated}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('dateCreated')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'DateCreated'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "DateCreated");
                              }}
                              onDoubleClick={() => autoFitColumn("DateCreated")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("assignedTo") &&
                          <th onClick={() => handleSort('DisplayName')}

                            style={{
                              width: `${columnWidths?.DisplayName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('assignedTo')}
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'DisplayName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "DisplayName");
                              }}
                              onDoubleClick={() => autoFitColumn("DisplayName")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Jprice") &&
                          <th onClick={() => handleSort('Prices')}

                            style={{
                              width: `${columnWidths?.Prices}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('price')}</th>
                        }
                        {visibleColumns.includes("LastActioned") &&
                          <th onClick={() => handleSort('LastActioned')}

                            style={{
                              width: `${columnWidths?.LastActioned}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Last Action
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'LastActioned'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "LastActioned");
                              }}
                              onDoubleClick={() => autoFitColumn("LastActioned")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }

                        {visibleColumns.includes("vc_SupplierInvoiceNo") &&
                          <th onClick={() => handleSort('vc_SupplierInvoiceNo')}
                            style={{
                              width: `${columnWidths?.vc_SupplierInvoiceNo}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Cust. Order No.
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_SupplierInvoiceNo'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_SupplierInvoiceNo");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_SupplierInvoiceNo")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("Address1") &&
                          <th onClick={() => handleSort('Address1')}
                            style={{
                              width: `${columnWidths?.Address1}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Address
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'Address1'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "Address1");
                              }}
                              onDoubleClick={() => autoFitColumn("Address1")}
                            />
                          </th>
                        }


                        {visibleColumns.includes("Jstatus") &&
                          <th onClick={() => handleSort('StatusName')}

                            style={{
                              width: `${columnWidths?.StatusName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">{t('status')}</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {jobList.map((job, index) => (

                        <tr key={job.IssueID} onClick={() => handleEditClick(job.IssueID)}

                          style={{
                            cursor: 'pointer',
                            backgroundColor: job.LastAction === 1
                              ? 'rgb(245 218 215)'
                              : job.IssueID.toString() === selectedId.toString()
                                ? 'rgb(197, 218, 237)' // Change this to any color you prefer
                                : ''
                          }}>
                          <td
                            className="checkbox-cell"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "40px",
                              minWidth: "40px",
                              maxWidth: "40px",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              backgroundColor:
                                selectedId.toString() === job.IssueID.toString()
                                  ? 'rgb(197, 218, 237)'
                                  : '#fff'
                            }}
                          >
                            <div
                              className="checkbox-hover-area"
                              onClick={(event) => handleCheckboxClick(event, job.IssueID, index)}
                            >
                              <input
                                type="checkbox"
                                checked={multipleIds.includes(job.IssueID)}
                                readOnly
                              />
                            </div>
                          </td>
                          {visibleColumns.includes("jobNo") &&
                            <td style={{
                              width: columnWidths.bnt_OrderNumber,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={job.bnt_OrderNumber}>
                              {job.bnt_OrderNumber}

                            </td>
                          }
                          {visibleColumns.includes("jcustomer") &&
                            <td style={{
                              width: columnWidths.CompanyName,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={job.CompanyName}>
                              {job.CompanyName}
                            </td>
                          }

                          {visibleColumns.includes("priority") &&
                            <td style={{
                              width: columnWidths.PriorityName,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">

                              {job.Icon ? (
                                job.Icon.includes('Default/SuperAdmin') ? (
                                  <img title={job.PriorityName}
                                    src={`${BASE_URL}/${job.Icon}`}

                                  />
                                ) : (
                                  <img title={job.PriorityName} src={`${BASE_URL}/uploads/${CompanyID}/Setup/Priority/${job.Icon}`} alt="Icon" />
                                )
                              ) : (
                                <img title={job.PriorityName}
                                  src={`${BASE_URL}/uploads/default-icon.png`}

                                />
                              )}



                            </td>
                          }
                          {visibleColumns.includes("category") &&

                            <td style={{
                              width: columnWidths.CategoryName,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={job.CategoryName}>
                              {job.CategoryName}
                            </td>
                          }
                          {visibleColumns.includes("Jdescription") &&
                            <td style={{
                              width: columnWidths.IssueTitle,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={job.IssueTitle}>
                              {job.IssueTitle}
                            </td>
                          }
                          {visibleColumns.includes("JdueDate") &&
                            <td style={{
                              width: columnWidths.TimeToCall,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">

                              {formatDateWithFns(job.TimeToCall, activeDateFormat)}
                            </td>
                          }
                          {visibleColumns.includes("JdateCreated") &&
                            <td style={{
                              width: columnWidths.DateCreated,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">
                              {formatDateWithFns(job.DateCreated, activeDateFormat)}

                            </td>
                          }
                          {visibleColumns.includes("assignedTo") &&
                            <td style={{
                              width: columnWidths.AssignedTo,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis" title={job.AssignedTo}>

                              {job.AssignedTo}

                            </td>
                          }
                          {visibleColumns.includes("Jprice") && <td>{job.Symbol}{job.Prices}</td>}
                          {visibleColumns.includes("LastActioned") && <td style={{
                            width: columnWidths.LastActioned,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(job.LastActioned, activeDateFormat)}  </td>}

                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {job.ModifiedBy ? (
                              <div
                                title={job.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {job.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("vc_SupplierInvoiceNo") && <td style={{
                            width: columnWidths.vc_SupplierInvoiceNo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{job.vc_SupplierInvoiceNo}  </td>}

                          {visibleColumns.includes("Address1") && <td style={{
                            width: columnWidths.Address1,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{job.Address1}  </td>}

                          {visibleColumns.includes("Jstatus") &&
                            <td style={{
                              width: columnWidths.StatusName,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">

                              {job.IsIcon ? (
                                job.IsIcon.includes('Default/SuperAdmin') ? (
                                  <img
                                    src={`${BASE_URL}/${job.IsIcon}`}
                                    title={job.StatusName}
                                  />
                                ) : (
                                  <img title={job.StatusName} src={`${BASE_URL}/uploads/${CompanyID}/Setup/Status/${job.IsIcon}`} alt="Icon" />
                                )
                              ) : (
                                <img title={job.StatusName}
                                  src={`${BASE_URL}/uploads/default-icon.png`}

                                />
                              )}
                            </td>
                          }

                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>

                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(JobCount, pageSize))} of {JobCount} entries
                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} /> Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} /> First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>


                  {/* Page Size Selector */}

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      {isJobModalOpen && (
        <JobDetailModal JobID={localStorage.getItem('JobID')} onClose={handleCloseModal} onSuccess={fetchJob} CustomerID={CustomerID} engineersData={[]} />
      )}
      {isModalOpen && (
        <CreateJobSummary JobID={localStorage.getItem('JobID')} onClose={handleCloseSummaryModal} onSuccess={handleSuccessSummaryModal} ClientCompanyID={CustomerID} />
      )}
      {showPdfModal && pdfUrl && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <Draggable handle=".modal-content" onStart={handleStart}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">PDF Report</h5>
                  <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                </div>
              </div>
            </Draggable>
          </div>
        </div>
      )}
      {isMultipleEmailModalOpen && (
        <SendAttachment onClose={handleCloseEmailModal} ToEmail={Email} pdfAttachment={pdfAttachment} ReportName="JobSheet.pdf" />
      )}
    </div>
  );
}
export default JobList;